/** Thai strings for this area (English source text -> Thai). */
export const NOTEBOOK: Record<string, string> = {
  // NotebookScene: top bar and tabs
  'Notebook sections': 'หมวดในสมุด',
  Coins: 'เหรียญ',
  '← Menu': '← เมนู',
  'My Notebook': 'สมุดของฉัน',
  'How to Play': 'วิธีเล่น',
  Hero: 'ฮีโร่',
  Monsters: 'มอนสเตอร์',
  Equipment: 'อุปกรณ์',
  Quests: 'เควสต์',
  Memories: 'ความทรงจำ',
  Friends: 'เพื่อน',
  Settings: 'ตั้งค่า',
  '{label}, {n} new friend request': '{label}, มีคำขอเป็นเพื่อนใหม่ {n} รายการ',
  '{label}, {n} new friend requests': '{label}, มีคำขอเป็นเพื่อนใหม่ {n} รายการ',

  // Hero panel (left page)
  'Hero Profile': 'ประวัติฮีโร่',
  'No hero drawn yet!': 'ยังไม่ได้วาดฮีโร่เลย!',
  'Every legend starts with a doodle.': 'ตำนานทุกเรื่องเริ่มจากรูปวาดเล่น ๆ',
  'Create a Hero': 'สร้างฮีโร่',
  'Spend a point: {stat} {per}': 'ใช้แต้ม: {stat} {per}',
  '{stat} is already maxed out!': '{stat} เต็มแล้ว!',
  'Empty slot — open Equipment': 'ช่องว่าง — เปิดหน้าอุปกรณ์',
  '— empty —': '— ว่าง —',
  Level: 'เลเวล',
  '{name}, drawn as a doodle': '{name} ในแบบรูปวาด',
  '{n} stat point to spend!': 'มีแต้มสเตตัส {n} แต้มให้ใช้!',
  '{n} stat points to spend!': 'มีแต้มสเตตัส {n} แต้มให้ใช้!',
  'Skill: {name}': 'สกิล: {name}',
  'New skill at level {level}: {name}': 'สกิลใหม่ที่เลเวล {level}: {name}',
  'Power {power} · arena budget {budget}': 'พลัง {power} · งบสนามประลอง {budget}',

  // Hero roster
  'My Heroes': 'ฮีโร่ของฉัน',
  'Pick who goes on the adventure.': 'เลือกว่าใครจะออกผจญภัย',
  'Equipped skill': 'สกิลที่ใช้อยู่',
  PLAYING: 'กำลังเล่น',
  'Play as': 'เล่นตัวนี้',
  Redraw: 'วาดใหม่',
  Rename: 'เปลี่ยนชื่อ',
  'Rename hero': 'เปลี่ยนชื่อฮีโร่',
  'New name': 'ชื่อใหม่',
  Delete: 'ลบ',
  'Erase hero?': 'ลบฮีโร่ไหม?',
  'Rub {name} out of the notebook forever?': 'ลบ {name} ออกจากสมุดไปตลอดกาลเลยนะ?',
  Erase: 'ลบเลย',
  'New Hero': 'ฮีโร่ใหม่',

  // Hero creation
  "Your hero's name": 'ชื่อฮีโร่ของคุณ',
  'Hero name': 'ชื่อฮีโร่',
  'Write a name, pick a class, then use the doodle or draw your own.': 'ตั้งชื่อ เลือกอาชีพ แล้วใช้รูปที่มีให้หรือวาดเองก็ได้',
  Name: 'ชื่อ',
  'Use this doodle': 'ใช้รูปนี้แหละ',
  '{name} joined the notebook': '{name} เข้ามาอยู่ในสมุดแล้ว',
  'A brand-new {cls}.': '{cls} คนใหม่เอี่ยม',
  '{name} is ready for adventure!': '{name} พร้อมผจญภัยแล้ว!',
  '✏ Draw my own hero': '✏ วาดฮีโร่เอง',

  // Monsters
  '{tier} · by {name}': '{tier} · โดย {name}',
  'Draw a hero first — monsters need someone to fight!': 'วาดฮีโร่ก่อนนะ — มอนสเตอร์ต้องมีคนให้สู้ด้วย!',
  'Fight!': 'สู้เลย!',
  Edit: 'แก้ไข',
  Share: 'แชร์',
  'Erase monster?': 'ลบมอนสเตอร์ไหม?',
  'Rub out {name}?': 'ลบ {name} ทิ้งเลยไหม?',
  DEFEATED: 'ชนะแล้ว',
  CLASSROOM: 'ห้องเรียน',
  'Practice only (no rewards)': 'ฝึกซ้อมเท่านั้น (ไม่มีรางวัล)',
  'Reward: {exp} EXP · {coins} coins': 'รางวัล: {exp} EXP · {coins} เหรียญ',
  'Got {monster} from {name}': 'ได้ {monster} จาก {name}',
  'Share code {code}.': 'รหัสแชร์ {code}',
  '{name} was taped into your notebook!': 'แปะ {name} ลงในสมุดของคุณแล้ว!',
  'Could not import that monster.': 'นำเข้ามอนสเตอร์ตัวนั้นไม่ได้',
  'a friend': 'เพื่อนคนหนึ่ง',
  '{name} imported!': 'นำเข้า {name} แล้ว!',
  'That file is not a Paper Legends monster ({reason}).': 'ไฟล์นี้ไม่ใช่มอนสเตอร์ของ Paper Legends ({reason})',
  unreadable: 'อ่านไม่ออก',
  'Share code': 'รหัสแชร์',
  'Import monster file': 'นำเข้าไฟล์มอนสเตอร์',
  'Monster Collection': 'คอลเลกชันมอนสเตอร์',
  'Pick a page and pick a fight.': 'เลือกหน้า แล้วเลือกคู่สู้เลย',
  'Back of the Book': 'ท้ายเล่ม',
  'My Doodles': 'รูปวาดของฉัน',
  'Draw a Monster': 'วาดมอนสเตอร์',
  'From Friends': 'จากเพื่อน',
  'Import code': 'ใส่รหัส',
  'Share codes have 6 letters/numbers.': 'รหัสแชร์มี 6 ตัวอักษร/ตัวเลขนะ',
  'Import file': 'นำเข้าไฟล์',
  'Ask a friend for a share code!': 'ขอรหัสแชร์จากเพื่อนสิ!',

  // Equipment
  'Pencil case, backpack and the school shop.': 'กล่องดินสอ กระเป๋า และร้านค้าโรงเรียน',
  Unequip: 'ถอดออก',
  'Create a hero to wear equipment.': 'สร้างฮีโร่ก่อนถึงจะใส่อุปกรณ์ได้',
  'My Backpack': 'กระเป๋าของฉัน',
  WORN: 'ใส่อยู่',
  Equip: 'ใส่',
  'Empty! Win battles or visit the shop.': 'ว่างเปล่า! ไปชนะการต่อสู้หรือแวะร้านค้าสิ',
  'School Shop': 'ร้านค้าโรงเรียน',
  Buy: 'ซื้อ',
  'Not enough coins yet': 'เหรียญยังไม่พอ',
  'Buy {name}': 'ซื้อ {name}',
  'Bought {name}!': 'ซื้อ {name} แล้ว!',

  // Quests
  'Quest Pages': 'หน้าเควสต์',
  'Homework, but fun.': 'เหมือนการบ้าน แต่สนุกกว่า',
  '{exp} EXP · {coins} coins': '{exp} EXP · {coins} เหรียญ',
  'Claim!': 'รับรางวัล!',
  'Quest complete: {name}!': 'ทำเควสต์สำเร็จ: {name}!',

  // Memories
  'Dear diary…': 'ไดอารี่ที่รัก…',
  'Nothing here yet. Go make some memories!': 'ยังไม่มีอะไรเลย ไปสร้างความทรงจำกันเถอะ!',

  // Friends
  'Opening the class address book…': 'กำลังเปิดสมุดรายชื่อห้อง…',
  'Friend code': 'รหัสเพื่อน',
  'Friend codes have 8 letters/numbers, like ABCD-EFGH.': 'รหัสเพื่อนมี 8 ตัวอักษร/ตัวเลข เช่น ABCD-EFGH',
  'You and {name} are now friends!': 'คุณกับ {name} เป็นเพื่อนกันแล้ว!',
  'Friend request sent to {name}.': 'ส่งคำขอเป็นเพื่อนถึง {name} แล้ว',
  'Something went wrong.': 'มีบางอย่างผิดพลาด',
  'online now': 'ออนไลน์อยู่',
  offline: 'ออฟไลน์',
  '{wins}W / {losses}L vs you': 'ชนะ {wins} / แพ้ {losses} เมื่อเจอคุณ',
  '{wins}W / {losses}L · last seen {date}': 'ชนะ {wins} / แพ้ {losses} · เจอกันล่าสุด {date}',
  'My Friends ({n})': 'เพื่อนของฉัน ({n})',
  'My Friends ({n} · {online} online)': 'เพื่อนของฉัน ({n} · ออนไลน์ {online})',
  'Invite to battle': 'ชวนมาสู้',
  'Invite {name} to a battle': 'ชวน {name} มาสู้กัน',
  '{name} is offline — invites need them online': '{name} ออฟไลน์อยู่ — ต้องออนไลน์ก่อนถึงจะชวนได้',
  Unfriend: 'เลิกเป็นเพื่อน',
  'Unfriend?': 'เลิกเป็นเพื่อนไหม?',
  'Remove {name} from your friends?': 'ลบ {name} ออกจากรายชื่อเพื่อนไหม?',
  '{name} was erased from your friends.': 'ลบ {name} ออกจากรายชื่อเพื่อนแล้ว',
  'No friends yet. Swap friend codes with a classmate!': 'ยังไม่มีเพื่อนเลย ลองแลกรหัสเพื่อนกับเพื่อนในห้องสิ!',
  'Your friend code — tell your classmates:': 'รหัสเพื่อนของคุณ — บอกเพื่อน ๆ ในห้องเลย:',
  'Copy code': 'คัดลอกรหัส',
  'Friend code copied!': 'คัดลอกรหัสเพื่อนแล้ว!',
  'Could not copy. Write it down instead!': 'คัดลอกไม่ได้ จดไว้แทนนะ!',
  'Add a Friend': 'เพิ่มเพื่อน',
  'Send request': 'ส่งคำขอ',
  'Friend Requests ({n})': 'คำขอเป็นเพื่อน ({n})',
  Accept: 'ตอบรับ',
  Decline: 'ปฏิเสธ',
  'Waiting for an Answer': 'รอคำตอบอยู่',
  Cancel: 'ยกเลิก',
  'Recent Rivals': 'คู่แข่งล่าสุด',
  'Add friend': 'เพิ่มเพื่อน',
  'Battle server offline — friends are unavailable right now.': 'เซิร์ฟเวอร์การต่อสู้ออฟไลน์ — ตอนนี้ใช้ระบบเพื่อนไม่ได้',
  'Could not load your friends.': 'โหลดรายชื่อเพื่อนไม่ได้',
  'Loading the class ranking…': 'กำลังโหลดอันดับในห้อง…',
  'Class Ranking': 'อันดับในห้อง',
  'No ranked battles yet.': 'ยังไม่มีการต่อสู้จัดอันดับเลย',
  'Battle server offline — ranking unavailable.': 'เซิร์ฟเวอร์การต่อสู้ออฟไลน์ — ดูอันดับไม่ได้',
  'Battle your friends and climb the class ranking.': 'สู้กับเพื่อน แล้วไต่อันดับของห้อง',

  // Bookmarks (cleaned-up nav) and the Collection pages
  PVP: 'PVP',
  Collection: 'คอลเลกชัน',
  'Fight Monsters': 'สู้มอน',
  'The next page of the story.': 'หน้าถัดไปของเนื้อเรื่อง',
  'My Monsters': 'มอนสเตอร์ของฉัน',
  'Monster Wiki': 'วิกิมอนสเตอร์',
  Diary: 'ไดอารี่',
  'Your doodles, contest winners and monsters from friends.': 'รูปวาดของเรา ผู้ชนะการประกวด และมอนสเตอร์จากเพื่อน',
  Stats: 'ค่าสเตตัส',
  'Signed in as': 'เข้าสู่ระบบในชื่อ',
  'Sign in to the battle server to add friends.': 'เข้าสู่ระบบเซิร์ฟเวอร์การต่อสู้เพื่อเพิ่มเพื่อน',
  'Sign in': 'เข้าสู่ระบบ',
  'Battle With Friends': 'สู้กับเพื่อน',
  'No rivals yet. Share a room code with a friend!': 'ยังไม่มีคู่แข่งเลย แชร์รหัสห้องให้เพื่อนสิ!',

  // Settings
  'Scribbled on the inside cover.': 'เขียนไว้ที่ปกด้านใน',
  'Auto (follow my device)': 'อัตโนมัติ (ตามเครื่องของฉัน)',
  Volume: 'ระดับเสียง',
  'Music volume': 'ระดับเสียงเพลง',
  'Mute sounds': 'ปิดเสียง',
  'Reduce motion': 'ลดการเคลื่อนไหว',
  'Follow my device': 'ตามเครื่องของฉัน',
  'On — calmer animations': 'เปิด — แอนิเมชันเบาลง',
  'Off — full animation': 'ปิด — แอนิเมชันเต็มที่',
  'Frame rate': 'เฟรมเรต',
  '30 FPS (battery saver)': '30 FPS (ประหยัดแบต)',
  Sharpness: 'ความคมชัด',
  'High (retina)': 'สูง (เรตินา)',
  Medium: 'กลาง',
  'Low (faster)': 'ต่ำ (เร็วกว่า)',
  'Show debug overlay (FPS, frame time, objects) — F3': 'แสดงข้อมูลดีบัก (FPS, เวลาต่อเฟรม, จำนวนวัตถุ) — F3',
  'Save & Load': 'บันทึกและโหลด',
  'Saved automatically in this browser.': 'บันทึกอัตโนมัติในเบราว์เซอร์นี้',
  'Saved automatically in this browser · last save {time}.': 'บันทึกอัตโนมัติในเบราว์เซอร์นี้ · บันทึกล่าสุด {time}',
  'Export notebook': 'ส่งออกสมุด',
  'Import notebook': 'นำเข้าสมุด',
  'Erase everything': 'ลบทุกอย่าง',
  'Erase the whole notebook?': 'ลบสมุดทั้งเล่มเลยไหม?',
  'Heroes, monsters, items and memories will be rubbed out. This cannot be undone.': 'ฮีโร่ มอนสเตอร์ ไอเทม และความทรงจำจะถูกลบหมด แล้วจะย้อนกลับไม่ได้นะ',
  'Erase it all': 'ลบทั้งหมด',
  'Import notebook file': 'นำเข้าไฟล์สมุด',
  'Load notebook?': 'โหลดสมุดไหม?',
  'This replaces your current notebook with the file.': 'สมุดเล่มปัจจุบันจะถูกแทนที่ด้วยไฟล์นี้',
  Load: 'โหลด',
  'Notebook loaded!': 'โหลดสมุดแล้ว!',
  'That file is not a Paper Legends notebook.': 'ไฟล์นี้ไม่ใช่สมุดของ Paper Legends',

  // Share modal
  'Share with a friend': 'แชร์ให้เพื่อน',
  'Tell your friend to type this code in Collection → From Friends to get {name}:': 'บอกเพื่อนให้พิมพ์รหัสนี้ที่ คอลเลกชัน → จากเพื่อน เพื่อรับ {name}:',
  Done: 'เสร็จแล้ว',
  'Copied!': 'คัดลอกแล้ว!',

  // Overview page and redesigned left page
  Home: 'หน้าแรก',
  Heroes: 'ฮีโร่',
  Gear: 'อุปกรณ์',
  'Hero journal and collections': 'บันทึกฮีโร่และของสะสม',
  'To next level:': 'อีกนิดถึงเลเวลถัดไป:',
  'Equipped Items': 'ของที่สวมใส่',
  Adventure: 'ผจญภัย',
  'Edit Hero': 'แก้ไขฮีโร่',
  'Next story fight: {name}': 'ด่านเนื้อเรื่องถัดไป: {name}',
  'Story complete — pick any monster': 'จบเนื้อเรื่องแล้ว — เลือกสู้กับมอนสเตอร์ตัวไหนก็ได้',
  'View All': 'ดูทั้งหมด',
  '{n} of {max} stars': '{n} จาก {max} ดาว',
  '“Monsters today, legends tomorrow!”': '“วันนี้เป็นมอนสเตอร์ พรุ่งนี้เป็นตำนาน!”',
  'Next Quests:': 'เควสต์ถัดไป:',
  'Finish the previous chapter to unlock': 'จบบทก่อนหน้าเพื่อปลดล็อก',
  'Complete!': 'สำเร็จ!',
  Boss: 'บอส',
  Replay: 'สู้อีกครั้ง',
  'Chapter reward: {coins} coins': 'รางวัลจบบท: {coins} เหรียญ',
  'The story so far — one page at a time.': 'เรื่องราวที่ผ่านมา ทีละหน้า',
  'Homework Quests': 'เควสต์การบ้าน',
  'Needs {n} stars': 'ต้องมี {n} ดาว',
  Graphics: 'การแสดงผล',
  'CPU — easy on the graphics card (recommended)': 'CPU — ไม่กินการ์ดจอ (แนะนำ)',
  'GPU — smoother on strong computers': 'GPU — ลื่นกว่าบนเครื่องแรงๆ',
  'Reload the game to switch.': 'โหลดเกมใหม่เพื่อเปลี่ยนการแสดงผล',
  Weapons: 'อาวุธ',
  Charms: 'เครื่องราง',
  'Weapons mostly add ATK: you hit harder.': 'อาวุธเพิ่มพลังโจมตี (ATK) เป็นหลัก ตีแรงขึ้น',
  'Armor adds HP and DEF: you last longer.': 'ชุดเกราะเพิ่มเลือด (HP) และพลังป้องกัน (DEF) อึดขึ้น',
  'Charms add LUCK (more critical hits) and a bit of everything.': 'เครื่องรางเพิ่มโชค (LUCK) ให้ติดคริบ่อยขึ้น และเพิ่มค่าอื่นนิดหน่อย',
  'My {category}': '{category}ของฉัน',
  'School Shop · {category}': 'ร้านค้าโรงเรียน · {category}',
  'None yet. Win story battles or buy one below.': 'ยังไม่มีเลย ชนะด่านเนื้อเรื่องหรือซื้อจากร้านด้านล่างได้',
  'You own everything in this category!': 'มีครบทุกชิ้นในหมวดนี้แล้ว!',
  '▲ Better than worn': '▲ ดีกว่าที่ใส่อยู่',
  '-{n} coins (lost {pct}%)': '-{n} เหรียญ (แพ้เสีย {pct}%)',
  'Dropped {n} coins.': 'ทำเหรียญหล่นไป {n} เหรียญ',
  'MAX +{n}': 'สูงสุด +{n}',
  'Upgrade {name} to +{n}': 'อัปเกรด {name} เป็น +{n}',
  '{item} +{n}!': '{item} +{n}!',
  'Upgraded for {coins} coins.': 'อัปเกรดด้วยเงิน {coins} เหรียญ',
  'Upgrade gear in your backpack with coins: each + adds a stat point.': 'เอาเหรียญมาอัปเกรดอุปกรณ์ในกระเป๋าได้ บวกละ 1 แต้มสเตตัส (ไอเทม HP ได้ +4 HP)',
  '👀 {name} spotted your habit! It counters a move you keep repeating — mix up Rock, Paper and Scissors.': '👀 {name} จับทางได้แล้ว! มันจะสวนท่าที่เราออกซ้ำๆ ลองสลับค้อน กระดาษ กรรไกรดูนะ',
  'Collect {n} stars to open this chapter': 'สะสมให้ครบ {n} ดาวเพื่อเปิดบทนี้',
  'Replay earlier stages and win with more HP left for more stars (★★ at half HP, ★★★ at 80%).': 'กลับไปสู้ด่านเก่าอีกครั้ง แล้วชนะโดยเหลือเลือดเยอะๆ เพื่อเก็บดาวเพิ่ม (เหลือครึ่งหนึ่งได้ ★★ เหลือ 80% ได้ ★★★)',
};
